export default "__VITE_ASSET__DumtF_KX__"